const version = "7.17.3";
export {
  version
};
//# sourceMappingURL=package.json.js.map
